export function brandRgb() {
  var hex = getComputedStyle(document.body).getPropertyValue('--cda-brand').trim() || '#A6388C';
  var n = parseInt(hex.replace('#', ''), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

export function startFallingLayer(options) {
  var canvas = document.createElement('canvas');
  canvas.className = 'cda-falling';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var particles = [];
  var width = 0;
  var height = 0;
  var frame = null;
  var last = 0;
  var lastScroll = window.pageYOffset;
  var MARGIN = 24;

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var count = Math.min(options.max, Math.round(width * height / options.density));
    while (particles.length < count) particles.push(options.make(width, height));
    particles.length = count;
  }

  function draw(dt) {
    ctx.clearRect(0, 0, width, height);
    var t = performance.now() / 1000;
    var scroll = window.pageYOffset;
    var scrolled = scroll - lastScroll;
    lastScroll = scroll;
    var span = height + MARGIN * 2;
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.y += p.speed * dt - scrolled;
      if (p.y > height + MARGIN || p.y < -MARGIN) {
        p.y = ((p.y + MARGIN) % span + span) % span - MARGIN;
        p.x = Math.random() * width;
      }
      options.draw(ctx, p, p.x + Math.sin(t * 0.6 + p.phase) * p.sway, dt, t);
    }
  }

  function tick(now) {
    var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
    last = now;
    draw(dt);
    frame = requestAnimationFrame(tick);
  }

  function play() {
    if (frame || document.hidden) return;
    last = 0;
    lastScroll = window.pageYOffset;
    frame = requestAnimationFrame(tick);
  }

  function pause() {
    if (frame) cancelAnimationFrame(frame);
    frame = null;
  }

  function onVisibility() { document.hidden ? pause() : play(); }
  document.addEventListener('visibilitychange', onVisibility);

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resize, 150);
  }
  window.addEventListener('resize', onResize);

  resize();
  play();

  return function stop() {
    pause();
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('resize', onResize);
    clearTimeout(resizeTimer);
    canvas.remove();
  };
}
